/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ResponseBoolean,
  VerifyCodeConfirmReqVo,
} from '../models/index';
import {
    ResponseBooleanFromJSON,
    ResponseBooleanToJSON,
    VerifyCodeConfirmReqVoFromJSON,
    VerifyCodeConfirmReqVoToJSON,
} from '../models/index';

export interface VerifyCodeConfirmPostRequest {
    verifyCodeConfirmReqVo?: VerifyCodeConfirmReqVo;
}

/**
 * 
 */
export class VerifyCodeControllerApi extends runtime.BaseAPI {

    /**
     * 确认验证码是否正确（短信/邮箱通用，只读校验不消费，验证码最终由各业务接口消费） 确认验证码是否正确 短信/邮箱验证码通用确认接口，按scene路由：REGISTER/RESET_PASSWORD/LOGIN传type+target，CHANGE_PASSWORD/CHANGE_BANK_CARD传userId。只读校验不消费验证码。同一IP每分钟最多10次，超限返回429
     * 确认验证码是否正确
     */
    async verifyCodeConfirmPostRaw(requestParameters: VerifyCodeConfirmPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/verifyCode/confirm`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VerifyCodeConfirmReqVoToJSON(requestParameters['verifyCodeConfirmReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 确认验证码是否正确（短信/邮箱通用，只读校验不消费，验证码最终由各业务接口消费） 确认验证码是否正确 短信/邮箱验证码通用确认接口，按scene路由：REGISTER/RESET_PASSWORD/LOGIN传type+target，CHANGE_PASSWORD/CHANGE_BANK_CARD传userId。只读校验不消费验证码。同一IP每分钟最多10次，超限返回429
     * 确认验证码是否正确
     */
    async verifyCodeConfirmPost(requestParameters: VerifyCodeConfirmPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.verifyCodeConfirmPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
